export default __webpack_public_path__ + "static/media/mark_6.cb3dc2bc.png";